import React from 'react';
import GridIcon from '../../icons/Grid';
import ListIcon from '../../icons/List';
import { viewModeType } from '../../store/review/types';

interface Props {
  viewMode: viewModeType;
  handleClick: (viewMode: viewModeType) => void;
}

const ViewModeSelector: React.FC<Props> = ({ viewMode, handleClick }) => {
  return (
    <div className="flex gap-x-4 mr-20 mobileCtrlViewModeSelector">
      <div className="mt-1 cursor-pointer" onClick={() => handleClick('cards')}>
        <GridIcon opacity={viewMode === 'cards' ? '1' : '0.25'} />
      </div>
      <div className="mt-1 cursor-pointer" onClick={() => handleClick('table')}>
        <ListIcon opacity={viewMode === 'table' ? '1' : '0.4'} />
      </div>
    </div>
  );
};

export default ViewModeSelector;
